import React, { Component } from 'react'
import '../styles/RegisteredFarmers.css'
import DropdownWidget from '../widgets/DropdownWidget'
import SwitchWidget from '../widgets/SwitchWidget'
import InputSearchWidget from '../widgets/InputSearchWidget'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIFarmerRequest from '../api/APIFarmerRequest'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import DatePicker from '../widgets/DatePicker'

class RegisteredFarmers extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			accountType: props.type,
			site: props.site,
		}
		this.onRegisterClick = this.onRegisterClick.bind(this)
		this.viewDetails = this.viewDetails.bind(this)
		this.handleSearch = this.handleSearch.bind(this)
		this.filterByOrganization = this.filterByOrganization.bind(this)
		this.filterByCluster = this.filterByCluster.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
		this.filterByStatus = this.filterByStatus.bind(this)
	}

	componentWillMount() {
		this.setState({showActivityIndicator: true})
		const allFarmers = APIFarmerRequest.getAllFarmersBySiteId(this.state.accessToken, this.props.site)
		allFarmers.then((response) => {
			console.log('getAllFarmersBySiteId', response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const datesRegistered = {}
			const clusters = {}
			const allFarmers = {}
			let id = 0
			for(const v of response.results.rows) {
				datesRegistered[v.registration_date] = {id: id++, name: formatDate(v.registration_date)}
				let cn = v.cluster_name
				if(cn != null) {
					cn = v.cluster_name.toUpperCase()
				}
				clusters[v.cluster_name] = {id: id, name: cn}
				allFarmers[v.farmer_id] = v
			}
			const farmers = Object.values(allFarmers)
			console.log('farmers 1 -->', farmers)
			farmers.sort((a, b) => {
				return(a.last_name.localeCompare(b.last_name))
			})
			console.log('farmers 2 -->', farmers)
			const c = []
			c.push({id: 0, name: "ANY"})
			for(const k in clusters) {
				c.push(clusters[k])
			}
			const dr = []
			dr.push({id: 0, name: "ANY"})
			dr.push({id: 1, name: "CUSTOM"})
			for(const k in datesRegistered) {
				dr.push(datesRegistered[k])
			}
			this.setState({
				showActivityIndicator: false,
				allFarmers: farmers, // response.results.rows,
				datesRegistered: dr,
				clusters: c,
				listData: farmers // response.results.rows
			})
		})
	}

	handleSearch(searchVal) {
		if(searchVal == null) {
			this.setState({listData: null})
			return
		}
		if(this.state.allFarmers === undefined) {
			return
		}
		const byClass = []
		for(const v of this.state.allFarmers) {
			if(searchVal.classificationId == 0 || searchVal.classificationId == null) {
				byClass.push(v)
			}
			else {
				if(searchVal.classification === v.classification) {
					byClass.push(v)
				}
			}
		}
		const bySubClass = []
		for(const v of byClass) {
			if(searchVal.subClassId == 0 || searchVal.subClassId == null) {
				bySubClass.push(v)
			}
			else {
				if(searchVal.subClass === v.sub_classification) {
					bySubClass.push(v)
				}
			}
		}
		const dateSelected = {
			dateRegistered: searchVal.dateRegistered,
			dateFrom: searchVal.dateFrom,
			dateTo: searchVal.dateTo
		}
		if(searchVal.clusterId != 0 && searchVal.clusterId != null) {
			this.filterByCluster(searchVal.cluster, bySubClass, (fc) => {
				if(searchVal.statusId != null && searchVal.statusId !== "") {
					this.filterByStatus(searchVal.status, fc, (at) => {
						this.filterByDate(dateSelected, at, (bd) => {
							this.setState({listData: bd})
						})
					})
					return
				}
				this.filterByDate(dateSelected, fc, (bd) => {
					this.setState({listData: bd})
				})
			})
			return
		}
		if(searchVal.statusId != null && searchVal.statusId !== "") {
			this.filterByStatus(searchVal.status, bySubClass, (at) => {
				this.filterByDate(dateSelected, at, (bd) => {
					this.setState({listData: bd})
				})
			})
			return
		}
		this.filterByDate(dateSelected, bySubClass, (bd) => {
			this.setState({listData: bd})
		})
	}

	filterByOrganization(org, farmers, callback) {
		const frs = []
		for(const v of farmers) {
			if(v.organization != null) {
				if(org === v.organization.toUpperCase()) {
					frs.push(v)
				}
			}
		}
		callback(frs)
	}

	filterByCluster(cluster, farmers, callback) {
		const frs = []
		for(const v of farmers) {
			if(v.cluster_name != null) {
				if(cluster === v.cluster_name.toUpperCase()) {
					frs.push(v)
				}
			}
		}
		callback(frs)
	}

	filterByDate(dateSelected, farmers, callback) {
		const dr = new Date(dateSelected.dateRegistered)
		const df = new Date(dateSelected.dateFrom)
		const dt = new Date(dateSelected.dateTo)
		const frs = []
		for(const v of farmers) {
			const ds = new Date(v.registration_date)
			if(dateSelected.dateRegistered.toLowerCase() === "any") {
				frs.push(v)
			}
			else if(dr.getMonth() === ds.getMonth() && dr.getDate() === ds.getDate() && dr.getFullYear() === ds.getFullYear()) {
				frs.push(v)
			}
			else if(ds >= df && ds < dt) {
				frs.push(v)
			}
		}
		callback(frs)
	}

	filterByStatus(stat, farmers, callback) {
		const at = []
		for(const v of farmers) {
			if(stat == v.status) {
				at.push(v)
			}
		}
		callback(at)
	}

	viewDetails(id) {
		this.props.viewDetails("view-details", id)
	}

	onRegisterClick() {
		this.props.onRegisterClick("registration")
	}

	render() {
		return(<div id="registered-farmers">
			<div id="rf-search"><SearchFarmers datesRegistered={this.state.datesRegistered}
				clusters={this.state.clusters} submitSearch={this.handleSearch} /></div>
			<div id="rf-listview"><FarmersListView data={this.state.listData}
				site={this.state.site}
				onRegisterClick={this.onRegisterClick}
				viewDetails={this.viewDetails} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

const classifications = [
	{id: 0, name: "ANY CLASSIFICATION"},
	{id: 1, name: "ARB"},
	{id: 2, name: "NON-ARB"}
]

class SearchFarmers extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: JSON.parse(localStorage.getItem("siteId")),
			maxDate: sessionStorage.getItem("date-today"),
			subClass: "ANY SUB-CLASSIFICATION",
			dateRegistered: "ANY",
			cluster: "ANY",
			classification: "ANY CLASSIFICATION",
			isDisabled: true,
			status: "ANY",
			statuses: [
				{id: null, name: "ANY"},
				{id: 0, name: "INACTIVE"},
				{id: 1, name: "ACTIVE"}
			]
		}
	}

	componentWillMount() {
		const categories = APIFarmerRequest.getAllFarmerCategory(this.state.accessToken);
		categories.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			c.push({categoryId: 0, name: "ANY SUB-CLASSIFICATION", classificationId: 0});
			for(const v of response.results.rows) {
				c.push({id: v.category_id, name: v.name, classificationId: v.classification_id});
			}
			this.setState({subClassifications: c, allSubClasses: c});
		});
		const orgs = APIOrganizationRequest.getAllOrganizationsBySiteId(this.state.accessToken, this.state.siteId)
		orgs.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			c.push({id: 0, name: "ANY ORGANIZATION"});
			for(const v of response.results.rows) {
				c.push({id: v.arbo_id, name: v.name.toUpperCase()});
			}
			this.setState({organizations: c});
		})
	}

	componentDidUpdate(prevProps) {
		if(prevProps.datesRegistered != this.props.datesRegistered) {
			let dmin = this.props.datesRegistered[2]
			if(dmin != null) {
				const d = dmin.name.split("/")
				var dateMin = d[2] + "-" + d[0] + "-" + d[1]
			}
			this.setState({
				datesRegistered: this.props.datesRegistered,
				dateMin: dateMin,
				clusters: this.props.clusters
			})
		}
	}

	render() {
		return(<div className="search-bar">
			<div>SEARCH BY</div>
			<br/>
			<div style={{'margin-bottom': '5px'}}>Classification</div>
			<DropdownWidget placeholder={this.state.classification} list={classifications} onItemSelected={(id, value) => {
				const sc = []
				for(const v of this.state.allSubClasses) {
					if(v.classificationId == id) {
						sc.push(v)
					}
					else if(id == 0) {
						sc.push(v)
					}
				}
				this.setState({
					subClassifications: sc,
					classification: value,
					classificationId: id,
					subClass: "ANY SUB-CLASSIFICATION",
					subClassId: null
				})
			}} />
			<div style={{'margin-bottom': '5px'}}></div>
			<DropdownWidget placeholder={this.state.subClass} list={this.state.subClassifications} onItemSelected={(id, value) => {
				this.setState({subClass: value, subClassId: id})
			}} />
			<br/><br/>
			<div style={{'margin-bottom': '5px'}}>Date Registered</div>
			<DropdownWidget placeholder={this.state.dateRegistered} list={this.state.datesRegistered} cStyle={{'min-width': '100%'}} onItemSelected={(id, value) => {
				let isDisabled = true
				let dateFrom = ""
				let dateTo = ""
				let isCustom = false
				if(id == 1) {
					isDisabled = false
					dateFrom = this.state.dateMin
					dateTo = this.state.maxDate
					isCustom = true
				}
				this.setState({
					dateRegistered: value,
					isDisabled: isDisabled,
					dateFrom: dateFrom,
					dateTo: dateTo,
					isCustom: isCustom
				})
			}} />
			{this.state.isCustom && <div className="sb-date"><div className="sb-date-lbl">From</div>
				<div className="sb-date-cl">
					<DatePicker name="from" max={this.state.maxDate} value={this.state.dateFrom} onChange={(value) => {
						this.setState({dateFrom: value})
					}} disabled={this.state.isDisabled} />
				</div>
			</div>}
			{this.state.isCustom && <div className="sb-date"><div className="sb-date-lbl" style={{'text-align': 'right'}}>To</div>
				<div><DatePicker name="to" max={this.state.maxDate} value={this.state.dateTo} onChange={(value) => {
					this.setState({dateTo: value})
				}} disabled={this.state.isDisabled} /></div>
			</div>}
			<br/><br/>
			<div style={{'margin-bottom': '5px'}}>Status</div>
			<DropdownWidget list={this.state.statuses} onItemSelected={(id, value) => {
				this.setState({
					statusId: id,
					status: value,
				})
			}} placeholder={this.state.status} cStyle={{'min-width': '100%'}} />
			<br/>
			<button className="green-two" onClick={(e) => {
				const filter = {
					classification: this.state.classification,
					classificationId: this.state.classificationId,
					subClass: this.state.subClass,
					subClassId: this.state.subClassId,
					dateRegistered: this.state.dateRegistered,
					dateFrom: this.state.dateFrom,
					dateTo: this.state.dateTo,
					organization: this.state.organization,
					organizationId: this.state.organizationId,
					cluster: this.state.cluster,
					clusterId: this.state.clusterId,
					status: this.state.status,
					statusId: this.state.statusId
				}
				this.props.submitSearch(filter)
			}}>SEARCH</button>
			<button className="green-two" onClick={(e) => {
				this.setState({
					classification: "ANY CLASSIFICATION",
					classificationId: null,
					subClass: "ANY SUB-CLASSIFICATION",
					subClassId: null,
					dateRegistered: "ANY",
					dateFrom: "",
					dateTo: "",
					organization: null,
					organizationId: null,
					cluster: "ANY",
					clusterId: null,
					status: "ANY",
					statusId: null
				})
				this.props.submitSearch(null)
			}}>CLEAR</button>
		</div>)
	}
}

class FarmersListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			searchLabel: (props.data != null)? props.data.count + " result(s)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
			listItems: [],
			onRegisterClick: props.onRegisterClick
		}
		this.viewDetails = this.viewDetails.bind(this)
	}

	componentDidUpdate(prevProps) {
		if(this.props.data != prevProps.data) {
			if(this.props.data == null) {
				this.setState({
					searchLabel:  "PRESS THE SEARCH BUTTON TO SEE RESULTS",
					listItems: [],
					data: null
				})
				return
			}
			const listItems = []
			for(const v of this.props.data) {
				listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
			}
			this.setState({
				searchLabel:  this.props.data.length + " RESULT(S)",
				listItems: listItems,
				showActivityIndicator: false,
				data: this.props.data
			})
		}
	}

	viewDetails(id) {
		this.props.viewDetails(id)
	}

	render() {
		return(<div className="farmers-lv">
			<div className="flv-top">
				<InputSearchWidget placeholder="SEARCH RESULTS" cStyle={{'width': '285px'}}
					onSearchClick={(value) => {
						if(this.state.data == null) {
							return
						}
						const sr = searchString(value, this.state.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " RESULT(S)",
							listItems: listItems
						})
					}}
					onEnterPress={(value) => {
						if(this.state.data == null) {
							return
						}
						const sr = searchString(value, this.state.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " RESULT(S)",
							listItems: listItems
						})
					}} />
				<div className="flv-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="flv-header">
				<table className="flv-table-header">
					<col style={{width: '16%'}} />
					<col style={{width: '36%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '14%'}} />
					<col style={{width: '14%'}} />
					<tr>
						<th>REGISTRATION #</th>
						<th>FARMER'S NAME</th>
						<th>SUB-CLASSIFICATION</th>
						<th>DATE REGISTERED</th>
						<th>STATUS</th>
						<div className="flv-grid-btn"><button className="green-two" onClick={(e) => {
								this.state.onRegisterClick("hello")
							}}>REGISTER FARMER</button>
						</div>
					</tr>
				</table>
			</div>
			<div className="flv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="flv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

function ListItem(props) {
	let mi = ''
	if(props.data.middle_name != null) {
		mi = props.data.middle_name.charAt(0) + '.'
	}
	const extn = (props.data.extension_name != null)? props.data.extension_name: ""
	const name = `${props.data.last_name}, ${props.data.first_name} ${extn} ${mi}`
	if(props.data.cluster_name != null) {
		var cluster = props.data.cluster_name.toUpperCase()
	}
	return(<div className="fc-list-item">
			<table className="fc-table-data">
				<col style={{width: '16%'}} />
				<col style={{width: '36%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '14%'}} />
				<col style={{width: '14%'}} />
				<tr>
					<td>{props.data.registration_no}</td>
					<td>{name.toUpperCase()}</td>
					<td>{props.data.sub_classification}</td>
					<td>{formatDate(props.data.registration_date)}</td>
					<td>{props.data.status}</td>
					<div className="flv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							props.viewDetails(props.data.farmer_id)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

const formatDate = (d) => {
	if(d == null) {
		return
	}
	const date = new Date(d)
	var m = date.getMonth()+1
	if(date.getMonth() < 9) {
		m = "0" + (date.getMonth()+1)
	}
	var dt = date.getDate()
	if(date.getDate() < 9) {
		dt = "0" + date.getDate()
	}
	return(m + "/" + dt + "/" + date.getFullYear())
}

const searchString = (str, data) => {
	if(data.length < 1) {
		return
	}
	if(str == null) {
		str = ""
	}
	const list = []
	for(const v of data) {
		let mi = ''
		if(v.middle_name) {
			mi = v.middle_name.charAt(0)
		}
		const name = v.last_name +' '+ v.first_name +" "+ v.extension_name +" "+ mi
		if(name.toLowerCase().includes(str.toLowerCase()) || v.registration_no.includes(str)) {
			list.push(v)
		}
	}
	return(list)
}

export default RegisteredFarmers
